<template>
    
    <div class="con-box">
        
        <div class="user-level">当前水平：{{userLevel}}</div>

        <el-row>
            <el-col :span="12" :sm="12" :xs="24" v-for="(item, index ) in work_data" :key="index">
            <el-card class="box-card" >
                <el-row class="card-top">
                    <el-col :span="12">
                        {{item.work_name}}
                    </el-col>
                    <el-col :span="12">
                        <div class="learn-count">
                            参与人数：{{item.learn_count}}
                        </div>
                        
                    </el-col>
                </el-row>
                <el-row class="card-mid">
                    <el-col :span="3">
                        <img :src="source_prefix+item.img_url" alt="" style="width:100%">
                    </el-col>
                    <el-col :span="18" :offset="3">
                        <div style="padding-top:30px">
                        <span>
                            难度系数：
                        </span>
                        <img v-for="n in Number(item.difficulty_count)"  :src="source_prefix+'/jingying/word/2022/11/09/d96659e9cfb4ec467da4d7b8bbe5613e.png'" alt="">

                        <img v-for="v in (5 - Number(item.difficulty_count))"  :src="source_prefix+'/jingying/word/2022/11/09/2e127185ea90d8fdb891fe5c41f6c266.png'" alt="">

                        </div>

                    </el-col>
                </el-row>

                <el-row class="card-bottom">
                    <el-col :span="21" :offset="3">
                        <div class="btn-box">
                            <el-button type="primary" @click="testStart(item)" round>{{item.complete_flag == 'N' ? '开始测试' : '重新测试'}}</el-button>
                            <el-button v-if="item.report_list_flag == 'Y'" @click="viewReport(item)" round>查看报告</el-button>
                        </div>
               
                    </el-col>
                </el-row>

               

            </el-card>
            </el-col>
        </el-row>

    </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api'


export default defineComponent({
    setup() {

    },
})
</script>


<script>
    import { getLevelTestList} from '../api'
    import store from '@/store'
    import { checkLoginType } from '@/utils/common'
    export default {
        name: 'Home',
        props: ['cate', 'words'],
        data() {
            return {
                userLevel:"未知",
                images: [
                    "http://foo.ibianma.com/jingying/word/2022/11/08/9f900f9b14078b3a377a28467b0601e6.png"
                ],
                features: [],
                postList: [],
                currPage: 1,
                hasNextPage: false,
                form:{

                },
                user_data:[],
                work_data:[],
                source_prefix:process.env.VUE_APP_UPYUN_PATH,
            }
        },
        components: {
        },
        computed: {
        },
        methods: {
            getLevelTestFun()
            {
                getLevelTestList(this.form).then(response => {
                    this.user_data = response.user_data
                    this.work_data = response.work_data
                    if(this.user_data.length !=0)
                    {
                        this.userLevel = this.user_data[0].level_name
                    }
                })
            },
            testStart(e)
            {
                this.$router.push({path:'/homeworkanswer',query: {work_guid:e.work_guid}})

            },
            viewReport(e)
            {
                this.$router.push({path:'/viewreport',query: {work_guid:e.work_guid}})
            },
            loginout()
            {
                store.dispatch('user/logout');
            }
        },
        
        mounted() {
            this.form.id = this.$route.params.work_guid
            var res = "";
            this.getLevelTestFun()
        }
    }
</script>
<style scoped lang="less">
    .user-level{
        padding:20px 10px 20px 20px;
    }
    .con-box {
        padding: 0 2%;
        background-color: #fff;
    }
    .box-card{
        margin:0 10px 20px 10px;
        padding:20px;
    }
    .learn-count{
        color:#666;
        text-align: right;
    }
    .btn-box{
        text-align: right;
    }

    .content-card {
        margin-top:10px;
    }
    .card-top{
        margin-bottom:10px;
    }

    .site-content {
        .notify {
            margin: 60px 0;
            border-radius: 3px;
            & > div {
                padding: 20px;
            }
        }


        .search-result {
            padding: 15px 20px;
            text-align: center;
            font-size: 20px;
            font-weight: 400;
            border: 1px dashed #ddd;
            color: #828282;
        }
    }

    .top-feature {
        width: 100%;
        height: auto;
        margin-top: 30px;

        .feature-content {
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            position: relative;

            .feature-item {
                width: 32.9%;
            }
        }
    }

    .site-main {
        padding-top: 80px;

        &.search {
            padding-top: 0;
        }
    }

    .more{
        margin: 50px 0;
        .more-btn{
            width: 100px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            color: #ADADAD;
            border: 1px solid #ADADAD;
            border-radius: 20px;
            margin: 0 auto;
            cursor: pointer;
            &:hover{
                color: #8fd0cc;
                border: 1px dashed #8fd0cc;
            }
        }
    }

    /******/
    @media (max-width: 800px) {
        .top-feature {
            display: none;
        }

        .site-main {
            padding-top: 40px;
        }

        .site-content {
            .notify {
                margin: 30px 0 0 0;
            }

            .search-result {
                margin-bottom: 20px;
                font-size: 16px;
            }
        }
    }

    /******/
</style>
